class QueryDocument {
    static loadCSS(url: string) {
        return new Promise((resolve, reject) => {
            const link = document.createElement('link');
            link.href = url;
            link.rel = 'stylesheet';
            link.onload = () => resolve(url);
            link.onerror = () => reject(new Error(`Error loading CSS: ${url}`));
            document.head.appendChild(link);
        });
    }
      
    static loadScript(url: string) {
        return new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = url;
            script.async = true;
            script.onload = () => resolve(url);
            script.onerror = () => reject(new Error(`Error loading script: ${url}`));
            document.head.appendChild(script);
        });
    }
}